export const setMapReference = (map) => {
  return {
    type: 'SET_MAP_REFERENCE',
    payload: map
  }
}
export const setMapReferenceThreeD = (map) => {
  return {
    type: 'SET_THREE_D_MAP_REFERENCE',
    payload: map
  }
}